import { useMemo, useState, useCallback } from "react"

import dayjs from "config/dayjs"

import { useVenue } from "providers/venue"

export const useEvent = () => {
  const { features } = useVenue()
  const currentTime = dayjs()

  const [activeGroupEvent, setActiveGroupEvent] = useState("current")

  const events = useMemo(
    () => features.filter(({ feature_type }) => feature_type === "event"),
    [features]
  )

  const sortEventsByDate = useCallback((events) => {
    return events.sort(
      (firstEvent, secondEvent) =>
        dayjs(firstEvent.properties.start_date).valueOf() -
        dayjs(secondEvent.properties.start_date).valueOf()
    )
  }, [])

  const filteredCurrentEvent = useMemo(
    () =>
      events.filter((event) => {
        const { properties } = event
        const startDate = dayjs(properties?.start_date)
        const endDate = dayjs(properties?.end_date)

        return currentTime.isAfter(startDate) && currentTime.isBefore(endDate)
      }),
    [events, currentTime]
  )

  const filteredUpcomingEvent = useMemo(
    () =>
      events.filter((event) => {
        const { properties } = event
        const startDate = dayjs(properties?.start_date)
        return currentTime.isBefore(startDate)
      }),
    [events, currentTime]
  )

  const groupEvents = useMemo(
    () => ({
      current: sortEventsByDate(filteredCurrentEvent),
      upcoming: sortEventsByDate(filteredUpcomingEvent),
    }),
    [filteredCurrentEvent, filteredUpcomingEvent, sortEventsByDate]
  )

  const handleChange = useCallback((e, eventGroup) => {
    if (eventGroup === null) return
    setActiveGroupEvent(eventGroup)
  }, [])

  return {
    groupEvents,
    activeGroupEvent,
    handleChange,
  }
}
